import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import clsx from "clsx";
import Checkbox from "/components/common/checkbox";
import { safeLocalStorage } from "~/utils/safeStorage";
import { getFilterUrl } from "../../../../utils";
import { getFilter } from "../../../../redux/action-creaters/filter";
import styles from "./index.module.scss";
import Input from "/components/common/input";
import Button from "/components/common/button";
import Icon from "/components/common/icon";
import { filterSliderProps } from "../../../../utils/constants";

export default function Filter({
  sectionPageUrl,
  isShowMobileFilter,
  isBaltex = false,
}) {
  const dispatch = useDispatch();
  const { isNeedFilter, filter, params } = useSelector((state) => state.filter);
  const router = useRouter();

  useEffect(() => {
    if (isNeedFilter) {
      dispatch(getFilter(Boolean(router.query.reset)));
    }
  }, [isNeedFilter, params]);

  const paramsFormat = useMemo(() => {
    return params;
    // eslint-disable-next-line no-unreachable
    const paramsFormated = {};
    Object.keys(params).forEach((key) => {
      if (key.indexOf("-from") > -1) {
        paramsFormated[key.replace("-from", "")] = `from-${params[key]}`;
      } else if (key.indexOf("-to") > -1) {
        if (paramsFormated[key.replace("-to", "")]) {
          paramsFormated[key.replace("-to", "")] += `-to-${params[key]}`;
        } else {
          paramsFormated[key.replace("-to", "")] = `to-${params[key]}`;
        }
      } else {
        paramsFormated[key] = params[key];
      }
    });
    // eslint-disable-next-line no-unreachable
    return paramsFormated;
  }, [params]);

  const [isChanged, setIsChanged] = useState(false);

  const onChangeSlider = (itemCode, { min, max }) => {
    if (!isChanged) {
      return;
    }
    setIsChanged(false);

    if (min && +min < +filter.filtersCounts[itemCode].min) {
      // eslint-disable-next-line no-param-reassign
      min = filter.filtersCounts[itemCode].min;
      // eslint-disable-next-line no-use-before-define
      setChangedValues((items) => {
        return {
          ...items,
          [itemCode]: { ...items[itemCode], min },
        };
      });
    }
    if (min && +min >= +filter.filtersCounts[itemCode].max) {
      // eslint-disable-next-line no-param-reassign
      min = filter.filtersCounts[itemCode].max;
      // eslint-disable-next-line no-use-before-define
      setChangedValues((items) => {
        return {
          ...items,
          [itemCode]: { ...items[itemCode], min },
        };
      });
    }
    if (max && +max > +filter.filtersCounts[itemCode].max) {
      // eslint-disable-next-line no-param-reassign
      max = filter.filtersCounts[itemCode].max;
      // eslint-disable-next-line no-use-before-define
      setChangedValues((items) => {
        return {
          ...items,
          [itemCode]: { ...items[itemCode], max },
        };
      });
    }

    const value = [];
    if (min && min > filter.filtersCounts[itemCode].min) {
      value.push("from", min);
    } else if (min) {
      // eslint-disable-next-line no-use-before-define
      onChangeSliderValue(itemCode, { min: undefined });
    }
    if (
      max &&
      max < filter.filtersCounts[itemCode].max &&
      max > filter.filtersCounts[itemCode].min
    ) {
      value.push("to", max);
    } else if (max) {
      // eslint-disable-next-line no-use-before-define
      onChangeSliderValue(itemCode, { max: undefined });
    }

    router.push(
      getFilterUrl(sectionPageUrl, {
        ...paramsFormat,
        [itemCode]: value,
      }),
    );
  };

  const [changedValues, setChangedValues] = useState({});

  const onChangeSliderValue = (itemCode, newValues) => {
    if (
      // eslint-disable-next-line eqeqeq
      changedValues[itemCode]?.min == newValues.min &&
      // eslint-disable-next-line eqeqeq
      changedValues[itemCode]?.max == newValues.max
    ) {
      return;
    }
    setIsChanged(true);
    setChangedValues((items) => {
      return {
        ...items,
        [itemCode]: { ...items[itemCode], ...newValues },
      };
    });
  };

  const onChange = (filterCode, valueCode) => {
    const url = getFilterUrl(sectionPageUrl, paramsFormat, {
      [filterCode]: valueCode,
    });
    router.push(url);
  };

  const [customFilterStatuses, setCustomFilterStatuses] = useState({});

  useEffect(() => {
    const savedStatuses = safeLocalStorage.getItem("customFilterStatuses");
    if (savedStatuses) {
      try {
        setCustomFilterStatuses(JSON.parse(savedStatuses));
      } catch {
        setCustomFilterStatuses({});
      }
    }
  }, []);

  useEffect(() => {
    safeLocalStorage.setItem(
      "customFilterStatuses",
      JSON.stringify(customFilterStatuses),
    );
  }, [customFilterStatuses]);

  const filtersItemsStatus = useMemo(() => {
    return customFilterStatuses;
    // eslint-disable-next-line no-unreachable
    const status = {};
    /* filters.map(filter => {
            status[filter['ID']] = typeof customFilterStatuses[filter['ID']] === "undefined" ? !filter.CLOSED : customFilterStatuses[filter['ID']]
        }) */
    return status;
  }, [customFilterStatuses]);

  const totalCheckedCnt = useMemo(() => {
    return isBaltex
      ? Object.values(params).length > 1
      : Object.values(params).length > 0;
  }, [params, isBaltex]);

  const filterStruct = useMemo(() => {
    let items = filter.filtersCounts
      ? Object.entries(filter.filtersCounts)
      : [];

    if (isBaltex) {
      items = items
        .filter((item) => item[0] !== "proizvoditel")
        .filter((item) => item[0] !== "elektrika_v_komplekte");
    }

    return items;
  }, [filter]);

  return (
    <>
      <div
        className={clsx(
          styles.Filter,
          isShowMobileFilter && styles.FilterMobileShow,
        )}
      >
        {filterStruct.map(([filterCode, filterValues]) => (
          <div key={filterCode} className={styles.Item}>
            <span
              className={styles.Name}
              onClick={() => {
                setCustomFilterStatuses({
                  ...customFilterStatuses,
                  [filterCode]: !filtersItemsStatus[filterCode],
                });
                setCustomFilterStatuses({
                  [filterCode]: !filtersItemsStatus[filterCode],
                });
              }}
            >
              <span>
                {filterCode === "price"
                  ? "Цена, руб"
                  : filter.filterNames[filterCode]}
                {params[filterCode]?.length > 0 && (
                  <span className={styles.NameCnt}>
                    {params[filterCode].length}
                  </span>
                )}
              </span>
              <span
                className={clsx(
                  styles.Arrow,
                  filtersItemsStatus[filterCode] && styles.ArrowOpen,
                )}
              >
                <Icon id="arrowdown" width={12} height={12} fill={"#000"} />
              </span>
            </span>

            <div
              className={clsx(
                filtersItemsStatus[filterCode] && styles.wrapperOpened,
                styles.wrapper,
              )}
            >
              <div className={styles.inner}>
                {filterSliderProps.includes(filterCode) && (
                  <span>
                    <span className={styles.SliderVals}>
                      <Input
                        classProp={styles.Input}
                        placeholder={filterValues.min}
                        label={"От"}
                        value={changedValues[filterCode]?.min || ""}
                        onChange={(min) =>
                          onChangeSliderValue(filterCode, { min })
                        }
                        onBlur={(min) =>
                          onChangeSlider(filterCode, {
                            min,
                            max: changedValues[filterCode]?.max,
                          })
                        }
                      />
                      <Input
                        classProp={styles.Input}
                        placeholder={filterValues.max}
                        label={"До"}
                        value={changedValues[filterCode]?.max || ""}
                        onChange={(max) =>
                          onChangeSliderValue(filterCode, { max })
                        }
                        onBlur={(max) =>
                          onChangeSlider(filterCode, {
                            max,
                            min: changedValues[filterCode]?.min,
                          })
                        }
                      />
                    </span>

                    {/*
                                        <ReactSlider
                                            className={styles.Slider}
                                            thumbClassName={styles.Thumb}
                                            trackClassName={'track'}
                                            value={[
                                                changedValues[filterCode]?.min || filterValues.min,
                                                changedValues[filterCode]?.max || filterValues.max
                                            ]}
                                            min={filterValues.min}
                                            max={filterValues.max}
                                            renderThumb={(props) => <div {...props}></div>}
                                            pearling
                                            onAfterChange={([min, max]) => {
                                                console.log('min, max',min, max)
                                                onChangeSliderValue(filterCode, {min, max})
                                                onChangeSlider(filterCode, {min, max})
                                            }}
                                        /> */}
                  </span>
                )}
                {!filterSliderProps.includes(filterCode) &&
                  Object.entries(filterValues).map(([valueCode, count]) => (
                    <span key={valueCode} className={styles.Checkbox}>
                      <Checkbox
                        onChange={() => onChange(filterCode, valueCode)}
                        checked={params[filterCode]?.includes(valueCode)}
                        label={filter.filterValueNames[valueCode] || valueCode}
                      />
                      <span className={styles.Cnt}>{count}</span>
                    </span>
                  ))}
              </div>
            </div>
          </div>
        ))}
        {totalCheckedCnt > 0 && (
          <Button
            label={"Сбросить"}
            type={"outline"}
            onClick={() => {
              router.push(sectionPageUrl);
            }}
          />
        )}
      </div>
    </>
  );
}
